import { Discount } from 'entities/Discount';

export interface DiscountFormDrawerSchema {
  mode: Nullable<DrawerMode>;
  discount?: Nullable<Discount>;
}

export enum DrawerMode {
  DISCOUNT_EDIT = 'discount_edit',
  DISCOUNT_CREATE = 'discount_create',
}

export enum DiscountMode {
  CUSTOM = 'custom',
  MIN_RENTAL_DURATION = 'contractDuration',
  ENTIRE_PERIOD = 'all',
}

export interface DiscountSetting {
  period: string;
  value: number | string;
  type: '%' | '-';
  mode: DiscountMode;
}
